module.exports = require('./helpers/bundle-url').getBundleURL('37SUZ') + "logo.7718c6df.svg";